import {
	ChevronDoubleLeftIcon,
	ChevronDoubleRightIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
} from "@heroicons/react/20/solid";
import { useState } from "react";
import {format} from "date-fns";
// import { connect } from "react-redux";

const StatsTables = ({ stats, currency, section }) => {
	const [itemsPerPage, setItemsPerPage] = useState(15);
	const [page, setPage] = useState(0);
	const start = page * itemsPerPage;
	const end = (page + 1) * itemsPerPage;
	const lastPage = Math.ceil(stats?.length / itemsPerPage);

	const Pagination = () => {
		if (stats?.length <= 0) return null;
		return (
			<thead>
				<tr>
					<th colSpan={10}>
						<div
							style={{
								display: "grid",
								gridGap: "1.5rem",
								grid: "1.5rem",
								gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
							}}
						>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go To Page 1"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(0);
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 5 Pages"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(Math.max(page - 5, 0));
									}}
									disabled={page === 0}
								>
									<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-left"
									title="Go Back 1 Page"
									style={{ marginLeft: "0.5rem" }}
									onClick={() => {
										if (page != 0) setPage(page - 1);
									}}
									disabled={page === 0}
								>
									<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<strong>
									Page {page + 1}/{lastPage}
								</strong>
							</div>
							<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title={`Go to Page ${lastPage}`}
									onClick={() => {
										if (page !== lastPage - 1) setPage(lastPage - 1);
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									style={{ marginRight: "0.5rem" }}
									title="Go Forward 5 Pages"
									onClick={() => {
										if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
									}}
									disabled={page === lastPage - 1}
								>
									<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
								<button
									className="btn btn-xs btn-default pull-right"
									title="Go Forward 1 Page"
									onClick={() => {
										if (page !== lastPage - 1) setPage(page + 1);
									}}
									style={{ marginRight: "0.5rem" }}
									disabled={page === lastPage - 1}
								>
									<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
								</button>
							</div>
						</div>
					</th>
				</tr>
			</thead>
		);
	};

	return (
		<>
			<div className="col-xs-12 p-0 mt-5">
				<table className="table-responsive table table-hover m-0 mt-10">
					<Pagination />
				</table>
				<div
					className="col-xs-12 p-0"
					style={{ overflowX: "auto", maxWidth: "100%" }}
				>
					<table className="table-responsive table table-hover mt-0">
						<thead>
							<tr style={{ display: section == "people" ? "" : "none" }}>
								<th style={{ textAlign: "center" }}>Period</th>
								<th style={{ textAlign: "center" }}>Part-Time</th>
								<th style={{ textAlign: "center" }}>Full-Time</th>
								<th style={{ textAlign: "center" }}>Director</th>
								<th style={{ textAlign: "center" }}>Casual</th>
								<th style={{ textAlign: "center" }}>Contractors</th>
								<th style={{ textAlign: "center" }}>Casual Contractors</th>
								<th style={{ textAlign: "center" }}>Cis Contractors</th>
								<th style={{ textAlign: "center" }}>Off Payroll Workers</th>
								<th style={{ textAlign: "center" }}>Joiners</th>
								<th style={{ textAlign: "center" }}>Leavers</th>
								<th style={{ textAlign: "center" }}>Total Employees</th>
							</tr>
							<tr style={{ display: section == "payrolls" ? "" : "none" }}>
								<th>Period</th>
								<th style={{ textAlign: "center" }}>Gross</th>
								<th style={{ textAlign: "center" }}>Net</th>
								<th style={{ textAlign: "center" }}>Tax</th>
								<th style={{ textAlign: "center" }}>Total Cost</th>
								<th style={{ textAlign: "center" }}>Total Payrolls</th>
							</tr>
							<tr style={{ display: section == "businesses" ? "" : "none" }}>
								<th>Period</th>
								<th style={{ textAlign: "center" }}>Independent</th>
								<th style={{ textAlign: "center" }}>Paid By Advisor</th>
								<th style={{ textAlign: "center" }}>Total Businesses</th>
							</tr>
						</thead>
						<tbody>
							{stats?.slice(start, end)?.map((stat) => {
								return (
									<>
										<tr style={{ display: section == "people" ? "" : "none" }}>
											<td>{stat?.period}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.partTime}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.fullTime}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.director}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.casual}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.contractors}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.casualContractors}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.cisContractor}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.offPayrollWorker}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.joiners}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.leavers}</td>
											<td style={{ textAlign: "center" }}>{stat?.people?.count}</td>
										</tr>
										<tr style={{ display: section == "payrolls" ? "" : "none" }}>
											<td>{stat?.period}</td>
											<td style={{ textAlign: "center" }}>
												{currency}
												{parseFloat(stat?.payroll?.gross).toFixed(2)}
											</td>
											<td style={{ textAlign: "center" }}>
												{currency}
												{parseFloat(stat?.payroll?.net).toFixed(2)}
											</td>
											<td style={{ textAlign: "center" }}>
												{currency}
												{parseFloat(stat?.payroll?.tax).toFixed(2)}
											</td>
											<td style={{ textAlign: "center" }}>
												{currency}
												{parseFloat(stat?.payroll?.totalCost).toFixed(2)}
											</td>
											<td style={{ textAlign: "center" }}>{stat?.payroll?.count}</td>
										</tr>
										<tr style={{ display: section == "businesses" ? "" : "none" }}>
											<td>{stat?.period}</td>
											<td style={{ textAlign: "center" }}>
												{stat?.businesses?.count - stat?.businesses?.paidByAdvisor}
											</td>
											<td style={{ textAlign: "center" }}>{stat?.businesses?.paidByAdvisor}</td>
											<td style={{ textAlign: "center" }}>{stat?.businesses?.count}</td>
										</tr>
									</>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

const Pagination = ({ data, page, setPage, lastPage }) => {
	if (data?.length <= 0) return null;
	return (
		<thead>
			<tr>
				<th colSpan={10}>
					<div
						style={{
							display: "grid",
							gridGap: "1.5rem",
							grid: "1.5rem",
							gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
						}}
					>
						<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go To Page 1"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(0);
								}}
								disabled={page === 0}
							>
								<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go Back 5 Pages"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(Math.max(page - 5, 0));
								}}
								disabled={page === 0}
							>
								<ChevronDoubleLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-left"
								title="Go Back 1 Page"
								style={{ marginLeft: "0.5rem" }}
								onClick={() => {
									if (page != 0) setPage(page - 1);
								}}
								disabled={page === 0}
							>
								<ChevronLeftIcon style={{ height: "1.5em", float: "left" }} />
							</button>
						</div>
						<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
							<strong>
								Page {page + 1}/{lastPage}
							</strong>
						</div>
						<div style={{ gridColumn: "span 1 / span 3", textAlign: "center" }}>
							<button
								className="btn btn-xs btn-default pull-right"
								style={{ marginRight: "0.5rem" }}
								title={`Go to Page ${lastPage}`}
								onClick={() => {
									if (page !== lastPage - 1) setPage(lastPage - 1);
								}}
								disabled={page === lastPage - 1}
							>
								<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-right"
								style={{ marginRight: "0.5rem" }}
								title="Go Forward 5 Pages"
								onClick={() => {
									if (page !== lastPage - 1) setPage(Math.min(page + 5, lastPage - 1));
								}}
								disabled={page === lastPage - 1}
							>
								<ChevronDoubleRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
							<button
								className="btn btn-xs btn-default pull-right"
								title="Go Forward 1 Page"
								onClick={() => {
									if (page !== lastPage - 1) setPage(page + 1);
								}}
								style={{ marginRight: "0.5rem" }}
								disabled={page === lastPage - 1}
							>
								<ChevronRightIcon style={{ height: "1.5em", float: "left" }} />
							</button>
						</div>
					</div>
				</th>
			</tr>
		</thead>
	);
};

const PayrollTables = ({ upcoming, past }) => {
	const [itemsPerPage, setItemsPerPage] = useState(10);

	const [upcomingPage, setUpcomingPage] = useState(0);
	const upcomingStart = upcomingPage * itemsPerPage;
	const upcomingEnd = (upcomingPage + 1) * itemsPerPage;
	const upcomingLastPage = Math.ceil(upcoming?.length / itemsPerPage);

	const [overduePage, setOverduePage] = useState(0);
	const overdueStart = overduePage * itemsPerPage;
	const overdueEnd = (overduePage + 1) * itemsPerPage;
	const overdueLastPage = Math.ceil(past?.length / itemsPerPage);

	return (
		<>
			<div
				className="width-full grid grid-cols-2 wrap"
				style={{ gap: "20px" }}
			>
				<div
					className="col-xs-12 p-0"
					style={{ overflowX: "auto" }}
				>
					<span
						className="flex justify-center bold"
						style={{ fontSize: "1.2em" }}
					>
						Upcoming Payrolls
					</span>
					<table className="table-responsive table table-hover m-0">
						<Pagination
							data={upcoming}
							page={upcomingPage}
							setPage={setUpcomingPage}
							lastPage={upcomingLastPage}
						/>
					</table>
					<table className="table-responsive table table-hover mt-0">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Company</th>
								<th style={{ textAlign: "center" }}>Period</th>
								<th style={{ textAlign: "center" }}>Status</th>
								<th style={{ textAlign: "center" }}>Deadline</th>
							</tr>
						</thead>
						<tbody>
							{upcoming?.slice(upcomingStart, upcomingEnd)?.map((stat) => {
								return (
									<>
										<tr>
											<td style={{ textAlign: "center" }}>{stat?.name}</td>
											<td style={{ textAlign: "center" }}>{stat?.description}</td>
											<td style={{ textAlign: "center" }}>{stat?.status}</td>
											<td style={{ textAlign: "center" }}>{format(new Date(stat?.deadline),"dd MMM yyyy")}</td>
										</tr>
									</>
								);
							})}
						</tbody>
					</table>
				</div>
				<div
					className="col-xs-12 p-0"
					style={{ overflowX: "auto" }}
				>
					<span
						className="flex justify-center bold"
						style={{ fontSize: "1.2em" }}
					>
						Past Payrolls
					</span>
					<table className="table-responsive table table-hover m-0">
						<Pagination
							data={past}
							page={overduePage}
							setPage={setOverduePage}
							lastPage={overdueLastPage}
						/>
					</table>
					<table className="table-responsive table table-hover mt-0">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Company</th>
								<th style={{ textAlign: "center" }}>Period</th>
								<th style={{ textAlign: "center" }}>Status</th>
								<th style={{ textAlign: "center" }}>Deadline</th>
							</tr>
						</thead>
						<tbody>
							{past?.slice(overdueStart, overdueEnd)?.map((stat) => {
								return (
									<>
										<tr>
											<td style={{ textAlign: "center" }}>{stat?.name}</td>
											<td style={{ textAlign: "center" }}>{stat?.description}</td>
											<td style={{ textAlign: "center" }}>{stat?.status}</td>
											<td style={{ textAlign: "center" }}>{format(new Date(stat?.deadline),"dd MMM yyyy")}</td>
										</tr>
									</>
								);
							})}
						</tbody>
					</table>
				</div>
			</div>
		</>
	);
};

const AutomationTables = ({ upcoming, past }) => {
	const [itemsPerPage, setItemsPerPage] = useState(4);

	const [upcomingPage, setUpcomingPage] = useState(0);
	const upcomingStart = upcomingPage * itemsPerPage;
	const upcomingEnd = (upcomingPage + 1) * itemsPerPage;
	const upcomingLastPage = Math.ceil(upcoming?.length / itemsPerPage);

	const [pastPage, setPastPage] = useState(0);
	const pastStart = pastPage * itemsPerPage;
	const pastEnd = (pastPage + 1) * itemsPerPage;
	const pastLastPage = Math.ceil(past?.length / itemsPerPage);

	return (
		<div
			className="width-full grid grid-cols-2 wrap"
			style={{ gap: "20px" }}
		>
			<div
				className="col-xs-12 p-0"
				style={{ overflowX: "auto" }}
			>
				<span
					className="flex justify-center bold"
					style={{ fontSize: "1.2em" }}
				>
					Upcoming Automations
				</span>
				<table className="table-responsive table table-hover m-0">
					<Pagination
						data={upcoming}
						page={upcomingPage}
						setPage={setUpcomingPage}
						lastPage={upcomingLastPage}
					/>
				</table>
				<table className="table-responsive table table-hover mt-0">
					<thead>
						<tr>
							<th style={{ textAlign: "center" }}>Company</th>
							<th style={{ textAlign: "center" }}>Name</th>
							<th style={{ textAlign: "center" }}>Date</th>
						</tr>
					</thead>
					<tbody>
						{upcoming?.slice(upcomingStart, upcomingEnd)?.map((automation) => {
							return (
								<>
									<tr>
										<td style={{ textAlign: "center" }}>{automation?.company}</td>
										<td style={{ textAlign: "center" }}>{automation?.name}</td>
										<td style={{ textAlign: "center" }}>{format(new Date(automation.date), "dd MMM yyyy @ HH:mm")}</td>
									</tr>
								</>
							);
						})}
					</tbody>
				</table>
			</div>
			<div
				className="col-xs-12 p-0"
				style={{ overflowX: "auto" }}
			>
				<span
					className="flex justify-center bold"
					style={{ fontSize: "1.2em" }}
				>
					Past Automations
				</span>
				<table className="table-responsive table table-hover m-0">
					<Pagination
						data={past}
						page={pastPage}
						setPage={setPastPage}
						lastPage={pastLastPage}
					/>
				</table>
				<table className="table-responsive table table-hover mt-0">
					<thead>
						<tr>
							<th style={{ textAlign: "center" }}>Company</th>
							<th style={{ textAlign: "center" }}>Name</th>
							<th style={{ textAlign: "center" }}>Status</th>
							<th style={{ textAlign: "center" }}>Date</th>
						</tr>
					</thead>
					<tbody>
						{past?.slice(pastStart, pastEnd)?.map((automation) => {
							return (
								<>
									<tr>
										<td style={{ textAlign: "center" }}>{automation?.company}</td>
										<td style={{ textAlign: "center" }}>{automation?.name}</td>
										<td style={{ textAlign: "center" }}>{automation?.status}</td>
										<td style={{ textAlign: "center" }}>{format(new Date(automation.date), "dd MMM yyyy @ HH:mm")}</td>
									</tr>
								</>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

// const mapStateToProps = (state) => {};

// const mapDispatchToProps = (dispatch) => ({});

export { StatsTables, PayrollTables, AutomationTables };
